import { FC } from 'react';
import { Grid3X3, List } from 'lucide-react';
import { cn } from '../../utils/cn';

type ViewMode = 'grid' | 'list';

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export const ViewModeToggle: FC<ViewModeToggleProps> = ({ value, onChange }) => {
  return (
    <div
      className="flex items-center bg-gray-100 dark:bg-slate-700 rounded-lg p-1"
      role="group"
      aria-label="View mode"
    >
      <button
        type="button"
        onClick={() => onChange('grid')}
        className={cn(
          'flex items-center justify-center p-2 rounded-md transition-all duration-200',
          value === 'grid'
            ? 'bg-white dark:bg-slate-600 text-primary-600 dark:text-primary-400 shadow-sm dark:shadow-slate-900/30'
            : 'text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-300'
        )}
        aria-label="Grid view"
        aria-pressed={value === 'grid'}
      >
        <Grid3X3 className="h-5 w-5" aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={() => onChange('list')}
        className={cn(
          'flex items-center justify-center p-2 rounded-md transition-all duration-200',
          value === 'list'
            ? 'bg-white dark:bg-slate-600 text-primary-600 dark:text-primary-400 shadow-sm dark:shadow-slate-900/30'
            : 'text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-300'
        )}
        aria-label="List view"
        aria-pressed={value === 'list'}
      >
        <List className="h-5 w-5" aria-hidden="true" />
      </button>
    </div>
  );
};
